import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const CobrandUnitsTable = ({
    schools,
    setSelectedSchool,
    loading,
    editOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu 
                    editOnClick={editOnClick} 
                    id={item.clientSchoolID} 
                    item={item} 
                    deleteOnClick={deleteOnClick} 
                />
            ),
        },
        {
            name: 'Unit Name',
            fieldName: 'schoolName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'Client',
            fieldName: 'clientName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'Cobrand',
            fieldName: 'coBrandName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'Display On Signup',
            fieldName: 'displayOnSignup',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            onRender: (item) => item.displayOnSignup ? 'Yes' : 'No',
        },
        {
            name: 'User Facing Name',
            fieldName: 'userFacingName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
        },
    ];

    const items = schools ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedSchool(selectedItem && selectedItem.clientSchoolID);
    };

    return (
        <>
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={'schoolName'}
            style={{
                position: 'relative',
                height: '80vh',
                width: '80vw',
            }}
            CommandBar={
                <>
                    <CommandBarButton
                        iconProps={{ iconName: 'Add' }}
                        text="Add Unit"
                        onClick={() => createOnClick()}
                    />
                </>
            }
        />
        <FeatureSummary
            summary="This table displays all cobrand units (schools) for each client, including their names, associated client, cobrand, and display status. You can add, edit, or delete units. Units help organize users and reporting within a client."
        />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.schoolName || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CobrandUnitsTable;
